import { format } from 'date-fns';

/** Business date `yyyy-MM-dd` in the user's local day (never the UTC shift of toISOString). */
export const toBusinessDate = (d: Date) => format(d, 'yyyy-MM-dd');
